import React from 'react';
import { Shield, X, Check, Gift, Eye } from 'lucide-react';

const FreePhilosophySection = () => {
  const neverItems = [
    "d'abonnement payant",
    "de limitation du nombre de recherches ou de spots consultables", 
    "de fonctionnalités premium payantes"
  ];

  const potentialItems = [
    {
      icon: "🏪",
      title: "Des publicités locales et pertinentes",
      description: "restaurants à proximité des spots, commerces de proximité, événements locaux, fêtes communales"
    },
    {
      icon: "💝", 
      title: "Des dons volontaires facultatifs",
      description: "pour soutenir le projet"
    }
  ];

  return (
    <section id="free-philosophy" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex justify-center mb-6">
            <div className="p-4 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full">
              <Shield className="w-8 h-8 text-white" />
            </div>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-amber-900 mb-6">
            Notre philosophie : 100% gratuit
          </h2>
          <p className="text-xl text-amber-700 max-w-3xl mx-auto">
            Sans pub intrusive, sans abonnement
          </p>
        </div>

        {/* Main Promise */}
        <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-2xl p-8 md:p-12 mb-12">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold text-green-800 mb-6">
              Sun-Spot ne deviendra jamais payant
            </h3>
            <p className="text-xl text-gray-700 leading-relaxed mb-8">
              <span className="text-green-700 font-semibold">Il n'y aura aucune limitation sur le nombre de recherches ou de spots consultables, ni de fonctionnalités premium.</span>
            </p>
          </div>

          {/* Transparency Section */}
          <div className="bg-amber-50 rounded-xl p-8 border-l-4 border-amber-400">
            <h4 className="text-xl font-bold text-amber-800 mb-4">
              Si une monétisation s'avère nécessaire à terme, elle sera transparente :
            </h4>
            
            <div className="grid md:grid-cols-2 gap-6 mt-6">
              <div className="bg-white rounded-lg p-6 shadow-sm">
                <div className="flex items-start space-x-4">
                  <div className="text-2xl">🏪</div>
                  <div>
                    <h5 className="font-semibold text-green-700 mb-2 flex items-center">
                      <Check className="w-4 h-4 mr-2" />
                      Publicités locales pertinentes
                    </h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      restaurants, commerces locaux, événements proches des spots
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm">
                <div className="flex items-start space-x-4">
                  <div className="text-2xl">💝</div>
                  <div>
                    <h5 className="font-semibold text-green-700 mb-2 flex items-center">
                      <Check className="w-4 h-4 mr-2" />
                      Dons volontaires facultatifs
                    </h5>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      pour couvrir les coûts techniques
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Final Promise */}
        <div className="bg-gradient-to-r from-green-500 to-emerald-500 rounded-2xl text-white p-8 md:p-12">
          <div className="flex items-center justify-center mb-6">
            <Gift className="w-10 h-10 mr-4" />
            <h3 className="text-2xl md:text-3xl font-bold text-center">
              Notre priorité absolue
            </h3>
          </div>
          <p className="text-xl leading-relaxed text-center max-w-3xl mx-auto">
            <span className="font-bold">L'accès libre, gratuit et équitable pour tous.</span>
          </p>
        </div>

        {/* Trust Indicators */}
        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-green-50 rounded-xl">
            <div className="w-16 h-16 bg-green-200 rounded-full flex items-center justify-center mx-auto mb-4">
              <Shield className="w-8 h-8 text-green-600" />
            </div>
            <h4 className="text-lg font-bold text-green-800 mb-2">Engagement ferme</h4>
            <p className="text-gray-600 text-sm">Gratuit aujourd'hui, gratuit demain, gratuit toujours</p>
          </div>

          <div className="text-center p-6 bg-blue-50 rounded-xl">
            <div className="w-16 h-16 bg-blue-200 rounded-full flex items-center justify-center mx-auto mb-4">
              <Eye className="w-8 h-8 text-blue-600" />
            </div>
            <h4 className="text-lg font-bold text-blue-800 mb-2">Transparence totale</h4>
            <p className="text-gray-600 text-sm">Aucune surprise, aucun piège caché</p>
          </div>

          <div className="text-center p-6 bg-purple-50 rounded-xl">
            <div className="w-16 h-16 bg-purple-200 rounded-full flex items-center justify-center mx-auto mb-4">
              <Gift className="w-8 h-8 text-purple-600" />
            </div>
            <h4 className="text-lg font-bold text-purple-800 mb-2">Par passion</h4>
            <p className="text-gray-600 text-sm">Créé pour la communauté, pas pour le profit</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FreePhilosophySection;